import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiStandingOrder } from '../../../openapi';
import { useUpdateStandingOrderStatusMutation } from '../../../api/standing-orders';
import { useCallback, useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

export function TerminateStandingOrderDialog({
  open,
  order,
  onClose,
}: {
  open: boolean;
  order: ApiStandingOrder;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const mutation = useUpdateStandingOrderStatusMutation({ orderId: order.id });

  const handleTerminate = useCallback(() => {
    if (!mutation.isPending) {
      mutation.mutate({ status: 'TERMINATED' });
    }
  }, [mutation]);

  useEffect(() => {
    if (mutation.isSuccess) {
      navigate({ to: '/account/standing-orders' });
    }
  }, [mutation.isSuccess, navigate]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('Standing order termination')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {t(
            'Are you sure you want to terminate this standing order? This action cannot be undone.',
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Cancel')}</Button>
        <Button
          onClick={handleTerminate}
          loading={mutation.isPending}
          variant="contained"
          color="error"
        >
          {t('Terminate')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
